import { IController, module } from 'angular';
import { PageNavigationState, INavigationPage } from './pageNavigationState';

interface IPageSectionOnChanges extends ng.IOnChangesObject {
  visible: ng.IChangesObject<boolean>;
  label: ng.IChangesObject<string>;
  badge: ng.IChangesObject<string>;
}

class PageSectionController implements IController {
  public key: string;
  public label: string;
  public badge: string;
  public visible: boolean;
  public noWrapper: boolean;
  private pageConfig: INavigationPage;

  public constructor(private pageNavigationState: PageNavigationState) {}

  public $onInit(): void {
    this.visible = this.visible !== false;
    this.pageConfig = {
      key: this.key,
      label: this.label,
      visible: this.visible,
      badge: this.badge,
    };
    this.pageNavigationState.registerPage(this.pageConfig);
  }

  public $onChanges(changes: IPageSectionOnChanges): void {
    if (changes.visible && !changes.visible.isFirstChange()) {
      this.pageConfig.visible = changes.visible.currentValue;
    }
    if (changes.label && !changes.label.isFirstChange()) {
      this.pageConfig.label = changes.label.currentValue;
    }
    if (changes.badge && !changes.badge.isFirstChange()) {
      this.pageConfig.badge = changes.badge.currentValue;
    }
  }
}

class PageSectionComponent implements ng.IComponentOptions {
  public bindings: any = {
    key: '@',
    label: '@',
    badge: '<',
    visible: '<',
    noWrapper: '<',
  };
  public controller: any = PageSectionController;
  public transclude = true;
  public template = `
    <div ng-if="$ctrl.pageConfig.visible" class="page-subheading" data-page-id="{{$ctrl.pageConfig.key}}">
      <h4 class="sticky-header">{{$ctrl.pageConfig.label}}</h4>
      <div ng-class="$ctrl.noWrapper ? 'no-wrapper' : 'section-body'" data-page-content="{{$ctrl.pageConfig.key}}" ng-transclude></div>
    </div>
  `;
}

export const PAGE_SECTION_COMPONENT = 'spinnaker.core.presentation.navigation.pageSection';

module(PAGE_SECTION_COMPONENT, [])
  .component('pageSection', new PageSectionComponent());



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/presentation/navigation/pageSection.component.ts